import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, KeyRound } from 'lucide-react';
import AppIcon from '../components/AppIcon';
import { getErrorMessage } from '../api/errors';
import { authService } from '../services';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Şifre sıfırlama bağlantısı geçersiz veya eksik.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Şifreler eşleşmiyor.');
      return;
    }

    if (password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır.');
      return;
    }

    setLoading(true);

    try {
      const result = await authService.resetPassword({ token, newPassword: password });
      setMessage(result.message);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (err) {
      setError(getErrorMessage(err, 'Şifre güncellenemedi.'));
    } finally {
      setLoading(false);
    }
  };

  if (!token && !message) {
    return (
      <div className="container auth-page">
        <div className="auth-card">
          <div className="auth-header">
            <span className="auth-icon">
              <AppIcon icon={KeyRound} size={40} />
            </span>
            <h1>Şifre Sıfırlama</h1>
          </div>
          <div className="auth-error">Şifre sıfırlama bağlantısı geçersiz veya eksik.</div>
          <Link to="/auth/forgot-password" className="btn btn-primary btn-lg btn-block">
            Yeni Bağlantı İste
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon">
            <AppIcon icon={KeyRound} size={40} />
          </span>
          <h1>Yeni Şifre Belirle</h1>
          <p>Hesabınız için yeni bir şifre oluşturun.</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && (
          <>
            <div className="auth-success">{message}</div>
            <p className="auth-status">Giriş sayfasına yönlendiriliyorsunuz...</p>
          </>
        )}

        {!message && (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">Yeni Şifre</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="En az 6 karakter"
                required
                autoComplete="new-password"
                minLength={6}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Yeni Şifre Tekrar</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Şifrenizi tekrar girin"
                required
                autoComplete="new-password"
                minLength={6}
              />
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading}>
              {loading ? 'Kaydediliyor...' : 'Şifreyi Güncelle'}
            </button>
          </form>
        )}

        {!message && (
          <p className="auth-footer">
            <Link to="/login" className="icon-inline-link">
              <ArrowLeft size={16} aria-hidden />
              Giriş sayfasına dön
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
